module.exports = __webpack_public_path__ + "static/media/spoon.04208590.png";